// Permission constants for frontend
export const PERMISSIONS = {
    DASHBOARD: 'dashboard',
    JOBS: 'jobs',
    STOCK: 'stock',
    SUPPLIERS: 'suppliers',
    INVOICE: 'invoice',
    INCOME: 'income',
    USERS: 'users'
};

// Permission labels for UI
export const PERMISSION_LABELS = {
    dashboard: 'Dashboard',
    jobs: 'Jobs',
    stock: 'Stock',
    suppliers: 'Suppliers',
    invoice: 'Invoice',
    income: 'Income',
    users: 'Users'
};

// Related pages for each permission
export const PERMISSION_RELATED_PAGES = {
    [PERMISSIONS.DASHBOARD]: ['dashboard'],
    [PERMISSIONS.JOBS]: ['jobs', 'jobdetails', 'jobapplicantlist', 'jobagreement', 'nda'],
    [PERMISSIONS.STOCK]: ['jobsearch', 'stock'],
    [PERMISSIONS.SUPPLIERS]: ['projects', 'projectdetails', 'createproject'],
    [PERMISSIONS.INVOICE]: ['invoices', 'billdetails', 'bill'],
    [PERMISSIONS.INCOME]: ['income'],
    [PERMISSIONS.USERS]: ['users', 'profile']
};

// Check if user has permission
export const hasPermission = (userPermissions, requiredPermission) => {
    if (!userPermissions || !Array.isArray(userPermissions)) {
        return false;
    }
    return userPermissions.includes(requiredPermission);
};

// Check if user can access a specific page
export const canAccessPage = (userPermissions, pageName) => {
    if (!userPermissions || !Array.isArray(userPermissions)) {
        return false;
    }
    
    // Find which permission grants access to this page
    for (const [permission, pages] of Object.entries(PERMISSION_RELATED_PAGES)) {
        if (pages.some(p => p.toLowerCase() === pageName.toLowerCase())) {
            if (userPermissions.includes(permission)) {
                return true;
            }
        }
    }
    return false;
};

// Get all accessible pages for a user
export const getAccessiblePages = (userPermissions) => {
    if (!userPermissions || !Array.isArray(userPermissions)) {
        return [];
    }
    
    const pages = new Set();
    userPermissions.forEach(permission => {
        if (PERMISSION_RELATED_PAGES[permission]) {
            PERMISSION_RELATED_PAGES[permission].forEach(page => pages.add(page));
        }
    });
    
    return Array.from(pages);
};

// Get user permissions from localStorage
export const getUserPermissions = () => {
    try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        return userInfo.permissions || [];
    } catch (error) {
        console.error('Error getting permissions:', error);
        return [];
    }
};
